<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏 -->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>
                        检索：
                        <el-input placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                            <el-select v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                                <el-option
                                        v-for="item in keywordList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-input>
                    </div>
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                </div>
                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV">
                        <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true"></i>
                    </el-button>
                </div>
            </div>
            <div v-show="showFV" class="yx-flex-h-start" style="margin-top: 15px;">
                <div>
                    状态：
                    <el-select v-model="searchVal.agentStatId" placeholder="服务商状态" size="mini" clearable
                               style="width: 150px;margin-right: 15px;">
                        <el-option
                                v-for="item in agentStatuses"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    等级：
                    <el-select v-model="searchVal.agentLevelId" placeholder="服务商等级" size="mini" clearable
                               style="width: 150px;margin-right: 15px;">
                        <el-option
                                v-for="item in agentLevels"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    推荐人：
                    <el-select v-model="searchVal.agentPid" placeholder="服务商来源" size="mini" filterable  clearable
                               style="width: 150px;margin-right: 15px;">
                        <el-option
                                v-for="item in agentFromList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>

            </div>
            <div class="yx-flex-h-start" style="margin-top: 15px;">
                <el-button type="danger" icon="el-icon-plus" @click="viewAdd">新增服务商</el-button>
                <!-- 推荐人、等级、状态 单独控制权限，不在编辑里更新
                <el-button type="danger" icon="el-icon-user" @click="" :disabled="disableBtn">设置推荐人</el-button>
                <el-dropdown trigger="click" @command="changeAgentLevel">
                    <el-button type="danger" icon="el-icon-star-off" @click="" :disabled="disableBtn">
                        设置等级 <i class="el-icon-arrow-down el-icon--right" />
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item,index) in agentLevels" :key=index :command="item.id">{{item.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                -->
                <el-dropdown trigger="click" @command="changeAgentStatus">
                    <el-button type="danger" icon="el-icon-setting" @click="" :disabled="disableBtn">
                        更新状态 <i class="el-icon-arrow-down el-icon--right" />
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item,index) in agentStatuses" :key=index :command="item.id">{{item.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

            </div>
        </div>

        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :data="agents"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    @selection-change="handleSelectionChange"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%">
                <el-table-column type="selection" align="center"> </el-table-column>
                <el-table-column prop="agentCode" label="服务商编号" width="100"></el-table-column>
                <el-table-column prop="agentName" label="服务商名称" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="agentStatus.name" label="状态" width="100"></el-table-column>
                <el-table-column prop="agentLevel.name" label="等级" width="100"></el-table-column>
                <el-table-column prop="agentPidName" label="推荐人" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="legalPerson" label="法人" width="100"></el-table-column>
                <el-table-column prop="linkMan" label="联系人" width="100"></el-table-column>
                <el-table-column prop="linkPhone" label="联系电话" width="100"></el-table-column>
                <el-table-column prop="cityIdName" label="城市" width="100"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="info" plain size="mini" style="padding: 5px" @click="viewEdit(scope.row)">编辑</el-button>
                        <el-button type="primary" plain size="mini" style="padding: 5px" @click="viewDetail(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div style="width: 1px" />
            <!--
            <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
            -->
            <el-pagination
                    background
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="sizes, prev, pager, next, jumper, ->, total, slot"
                    :total="total">
            </el-pagination>
        </div>

        <el-drawer
                :title=agentInfo.agentName
                :with-header="false"
                :visible.sync="drawer"
                :show-close=false
                size = "60%"
                direction="rtl">
            <div style="padding: 0 10px 30px 10px">
                <el-table :data="[agentInfo]" style="padding-left: 0px">
                    <el-table-column prop="agentCode" label="编号" />
                    <el-table-column prop="agentLevel.name" label="等级" >
                        <!--
                        <template slot-scope="scope">
                            <el-tag type="success">{{scope.row.agentLevel.name}}</el-tag>
                        </template>
                        -->
                    </el-table-column>
                    <el-table-column prop="agentStatus.name" label="状态" />
                    <el-table-column prop="createTime" label="创建时间" />
                </el-table>
            </div>
<!--
            <AgentDetailDiv v-if="detailRest" v-bind:inAgentInfo="agentInfo"></AgentDetailDiv>
-->
            <AgentDetailDiv :key="agentInfo.id" v-bind:inAgentInfo="agentInfo"></AgentDetailDiv>
        </el-drawer>

        <el-dialog :visible.sync="showImgDlg">
            <div class="alignCenter"><img width="80%" :src="dlgImgUrl" alt="图片丢失"></div>
        </el-dialog>
        <!-- 对话框 编辑
        <el-dialog
                :title="titleDlg"
                :visible.sync="showDlg"
                :fullscreen=true
                :lock-scroll="false"
                :append-to-body="true"
                :close-on-click-modal="false"
                class="dlg-normal">
            <div>
                <el-form :model="agentInfo" :rules="rules" ref="agentForm" label-position="top">
                    <div class="tipTitle">基本信息</div>
                    <div class="form-s">
                        <el-row :gutter="30">
                            <el-col :span="c1">
                                <el-form-item label="服务商编号" prop="agentCode">
                                    <el-input size="small" v-model="agentInfo.agentCode" placeholder="服务商编号" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="c1">
                                <el-form-item label="服务商等级" prop="agentLevelId">
                                    <el-select v-model="agentInfo.agentLevelId" placeholder="服务商等级" size="small" :disabled="agentLevelDisabled"
                                               style="width: 100%;">
                                        <el-option
                                                v-for="item in agentLevels"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="c1">
                                <el-form-item label="服务商来源" prop="agentPid">
                                    <el-select v-model="agentInfo.agentPid" placeholder="推荐人" size="small" filterable :disabled="agentPidDisabled"
                                               style="width: 100%;">
                                        <el-option
                                                v-for="item in agentFromListTemp"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="c1">
                                <el-form-item label="服务商性质" prop="agentNatureId">
                                    <el-select v-model="agentInfo.agentNatureId" size="small" placeholder="服务商性质"
                                               style="width: 100%;">
                                        <el-option
                                                v-for="item in agentNatures"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="c1">
                                <el-form-item label="服务商名称" prop="agentName">
                                    <el-input size="small" v-model="agentInfo.agentName" placeholder="服务商名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="c1">
                                <el-form-item label="服务商简称" prop="shortName">
                                    <el-input size="small" v-model="agentInfo.shortName" placeholder="服务商简称" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="c2">
                                <el-form-item label="* 服务商地区">
                                    <AreaSelect v-if="areaRest" v-bind:inAreas="areas" v-bind:outAreas.sync="areas" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="c1">
                                <el-form-item label="详细地址" prop="addr">
                                    <el-input size="small" v-model="agentInfo.addr" placeholder="详细地址" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="c1">
                                <el-form-item label="联系人" prop="linkMan">
                                    <el-input size="small" v-model="agentInfo.linkMan" placeholder="联系人" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="c1">
                                <el-form-item label="联系电话" prop="linkPhone">
                                    <el-input size="small" v-model="agentInfo.linkPhone" placeholder="联系电话" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="c1">
                                <el-form-item label="联系邮箱" prop="linkMail">
                                    <el-input size="small" v-model="agentInfo.linkMail" placeholder="电子邮箱" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="c1">
                                <el-form-item label="法人姓名" prop="legalPerson">
                                    <el-input size="small" v-model="agentInfo.legalPerson" placeholder="法人姓名" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="c1">
                                <el-form-item label="法人电话" prop="legalPhone">
                                    <el-input size="small" v-model="agentInfo.legalPhone" placeholder="法人电话" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="c1">
                                <el-form-item label="法人身份证号" prop="legalIdcardNo">
                                    <el-input size="small" v-model="agentInfo.legalIdcardNo" placeholder="法人身份证号" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="c1">
                                <el-form-item label="营业执照编号" prop="licenseCode">
                                    <el-input size="small" v-model="agentInfo.licenseCode" placeholder="营业执照编号" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="c1">
                                <el-form-item label="营业执照图片" prop="licenseCode">
                                    <el-upload placeholder="营业执照图片"
                                               v-if="img1Rest"
                                               action="/pub/file/fileUpload"
                                               :file-list="licensePhotoArr"
                                               :limit="1"
                                               :on-success="handleSuccess"
                                               :on-remove="handleRemove"
                                               :on-preview="handlePreview"
                                               :before-upload="handleBef"
                                               :on-error="handleErr"
                                               list-type="picture-card"
                                               alt="图片丢失>~<"
                                               :class="{hide:hideUpload}">
                                        <i class="el-icon-plus"></i>
                                    </el-upload>

                                </el-form-item>
                            </el-col>
                        </el-row>

                    </div>
                    <el-divider></el-divider>
                    <div class="tipTitle">合同信息</div>
                    <div class="form-s">
                        <el-row :gutter="30">
                            <el-col :span="c1">
                                <el-form-item label="合同编号" prop="contractNo">
                                    <el-input size="small" v-model="agentInfo.contractNo" placeholder="合同编号" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="c1">
                                <el-form-item label="* 合同时间">
                                    <el-form-item prop='contractBeg'>
                                        <el-date-picker type="date" format="yyyy-MM-dd" style="width: auto" placeholder="开始日期" v-model="agentInfo.contractBeg" />
                                    </el-form-item>
                                    <el-form-item>&nbsp;-&nbsp;</el-form-item>
                                    <el-form-item prop='contractEnd'>
                                        <el-date-picker type="date" format="yyyy-MM-dd" style="width: auto" placeholder="结束日期" v-model="agentInfo.contractEnd" />
                                    </el-form-item>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <el-divider></el-divider>
                    <div class="tipTitle">结算账户</div>
                    <div class="form-s">
                        <el-row :gutter="30">
                            <el-col :span="c1">
                                <el-form-item label="账户类型" prop="stlAccTypeId">
                                    <el-select v-model="agentInfo.stlAccTypeId" size="small" placeholder="账户类型"
                                               style="width: 100%;">
                                        <el-option
                                                v-for="item in settleAccTypes"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="c3">
                                <el-form-item label="开户银行" prop="stlBankCnapsCode">
                                    <BankSelect v-if="bankRest" v-bind:inCnapsCode="agentInfo.stlBankCnapsCode" v-bind:outCnapsCode.sync="agentInfo.stlBankCnapsCode" />                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="c1">
                                <el-form-item label="开户名称" prop="stlAccName">
                                    <el-input size="small" v-model="agentInfo.stlAccName" placeholder="开户名称" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="c1">
                                <el-form-item label="银行卡号" prop="stlAccNo">
                                    <el-input size="small" v-model="agentInfo.stlAccNo" placeholder="银行卡号" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="c1">
                                <el-form-item label="开卡手机号" prop="stlAccPhone">
                                    <el-input size="small" v-model="agentInfo.stlAccPhone" placeholder="开卡手机号" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="c1">
                                <el-form-item label="开卡身份证号" prop="stlAccIdcardNo">
                                    <el-input size="small" v-model="agentInfo.stlAccIdcardNo" placeholder="开卡身份证号" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <el-divider></el-divider>
                    <div class="tipTitle">系统账号</div>
                    <div class="form-s">
                        <el-row :gutter="30">
                            <el-col :span="c1">
                                <el-form-item label="主账号名称" prop="sysName">
                                    <el-input size="small" v-model="agentInfo.sysName" placeholder="主账号名称" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="c1">
                                <el-form-item label="主账号" prop="sysUserName">
                                    <el-input size="small" v-model="agentInfo.sysUserName" placeholder="主账号" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="showDlg = false">取 消</el-button>
                <el-button size="small" type="primary" @click="dlgCommit">确 定</el-button>
            </span>
        </el-dialog>
        -->

        <AgentBaseDlg :key="keyCompDlg" v-bind:inShowDlg="showDlg" v-bind:inOptType="dlgModel" v-bind:inAgentInfo="agentInfo" v-bind:outRefreshData.sync="refreshData"/>

    </div>

</template>

<script>

    import {
        URL_FILE_UPLOAD,
        URL_AGENT_NATURES,
        URL_AGENT_LEVELS,
        URL_AGENT_STATUSES,
        URL_BANK_ACC_TYPES,
        URL_AREAS_PROV_CITY, URL_AGENT_FROMS
    } from "../../utils/cons";
    import AreaSelect from "../../components/pub/AreaSelect";
    import BankSelect from "../../components/pub/BankSelect";
    import {deepClone, findIdxByKeyValue} from '../../utils/datatool'
    import AgentDetailDiv from "../../components/agent/AgentDetailDiv";
    import AgentBaseDlg from "../../components/agent/AgentBaseDlg";

    export default {
        name: "AgentInfo",
        components: {AgentBaseDlg, AgentDetailDiv, AreaSelect,BankSelect},
        data() {
            return {
                drawer: false,
                hideUpload:false,
                disableBtn: true,
                optionProps: {
                    value: 'id',
                    label: 'name',
                    children: 'children'
                },
                c1: 6,
                c2: 12,
                c3: 18,
                c4: 24,
                agentPidDisabled: false,
                agentLevelDisabled: false,
                areaRest: true,
                bankRest: true,
                detailRest: true,
                img1Rest: true,
                dlgModel: '',
                keyCompDlg: null,
                titleDlg: '',
                showDlg: false,
                showImgDlg: false,
                dlgImgUrl:'',
                showFV: false,
                loading: false,
                total: 0,
                page: 1,
                size: 10,
                agents: [],
                agentFromList: [],
                agentFromListTemp: [],
                licensePhotoArr:[],
                areas:{},
                agentInfo: {
                    id: null,
                    agentCode: null,
                    agentName: null,
                    shortName: null,
                    provId: '',
                    provIdName: '',
                    cityId: '',
                    cityIdName: '',
                    distId: '',
                    distIdName: '',
                    addr: null,
                    tel: null,
                    linkMan: null,
                    linkPhone: null,
                    linkMail: null,
                    licenseCode: null,
                    licensePhoto: null,
                    legalPerson: null,
                    legalPhone: null,
                    legalIdcardNo: null,
                    legalIdcardPhoto: null,
                    contractNo: null,
                    contractBeg: null,
                    contractEnd: null,
                    agentFee: null,
                    recvAgentFee: null,
                    stlBankCnapsCode: null,
                    settleCnaps: {cnapsCode:null,cnapsName:null},
                    stlAccNo: null,
                    stlAccIdcardNo: null,
                    stlAccName: null,
                    stlAccPhone: null,
                    agentLevelId: null,
                    agentLevel: {id:null,name:null},
                    agentNatureId: null,
                    agentNature: {id:null,name:null},
                    stlAccTypeId: null,
                    settleAccType: {id:null,name:null},
                    agentStatusId: null,
                    agentStatus: {id:null,name:null},
                    agentPid: null,
                    agentPidName: null,
                    remark: null,
                    sysName: null,
                    sysUserName: null
                },
                rules: {
                    sysName: [{required: true, message: '请输入主账号名称', trigger: 'blur'}],
                    sysUserName: [{required: true, message: '请输入主账号', trigger: 'blur'}],
                    agentName: [{required: true, message: '请输入服务商名称', trigger: 'blur'}],
                    shortName: [{required: true, message: '请输入服务商简称', trigger: 'blur'}],
                    agentPid: [{required: true, message: '请选择服务商来源（推荐人）', trigger: 'blur'}],
                    addr: [{required: true, message: '请输入服务商详细地址', trigger: 'blur'}],
                    agentNatureId: [{required: true, message: '请选择服务商性质', trigger: 'blur'}],
                    linkMan: [{required: true, message: '请输入联系人', trigger: 'blur'}],
                    linkPhone: [{required: true, message: '请输入联系电话', trigger: 'blur'}],
                    linkMail: [{required: true, message: '请输入联系邮箱', trigger: 'blur'}, {
                        type: 'email',
                        message: '邮箱格式不正确',
                        trigger: 'blur'
                    }],
                    legalPerson: [{required: true, message: '请输入法人姓名', trigger: 'blur'}],
                    legalPhone: [{required: true, message: '请输入法人电话', trigger: 'blur'}],
                    legalIdcardNo: [{required: true, message: '请法人身份证号码', trigger: 'blur'}, {
                        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                        message: '身份证号码格式不正确',
                        trigger: 'blur'
                    }],
                    licenseCode: [{required: false, message: '请输入营业执照编号', trigger: 'blur'}],
                    contractNo: [{required: true, message: '请输入合同编号', trigger: 'blur'}],
                    contractBeg: [{required: true, message: '请选择合同开始日期', trigger: 'blur'}],
                    contractEnd: [{required: true, message: '请选择合同结束日期', trigger: 'blur'}],
                    stlAccTypeId: [{required: true, message: '请选择结算账户类型', trigger: 'blur'}],
                    stlBankCnapsCode: [{required: true, message: '请选择开户行', trigger: 'blur'}],
                    stlAccName: [{required: true, message: '请输入开户名称', trigger: 'blur'}],
                    stlAccNo: [{required: true, message: '请输入开户卡号', trigger: 'blur'}],
                    stlAccPhone: [{required: true, message: '请输入开户手机号', trigger: 'blur'}],
                    stlAccIdcardNo: [{required: true, message: '请输入开户身份证号', trigger: 'blur'}, {
                        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                        message: '身份证号码格式不正确',
                        trigger: 'blur'
                    }]
                },
                cityList:[],
                keywordList: [
                    {id:"agentName",name:"服务商名称"},
                    {id:"agentCode",name:"服务商编号"},
                    {id:"linkPhone",name:"联系电话"}
                    ],
                agentStatuses: [],
                agentLevels: [],
                agentNatures: [],
                settleAccTypes: [],
                multipleSelection: [],
                searchVal: {
                    keywordMethod: '',
                    keyword: '',
                    agentStatId: null,
                    agentLevelId: null,
                    agentPid: null
                }
            }
        },
        mounted() {
            this.initAgents();
            this.getRequest(URL_AGENT_LEVELS).then(resp => { if (resp) this.agentLevels = resp.data });
            this.getRequest(URL_AGENT_STATUSES).then(resp => { if (resp) this.agentStatuses = resp.data });
            this.getRequest(URL_AGENT_NATURES).then(resp => { if (resp) this.agentNatures = resp.data });
            this.getRequest(URL_BANK_ACC_TYPES).then(resp => { if (resp) this.settleAccTypes = resp.data });
            this.getRequest(URL_AREAS_PROV_CITY).then(resp => { if (resp) this.cityList = resp.data  });
            this.getRequest(URL_AGENT_FROMS).then(resp => { if (resp) this.agentFromList = resp.data  });
        },
        methods: {
            handleBef() {
                this.hideUpload = true;
            },
            handlePreview(file) {
                this.dlgImgUrl = file.url;
                this.showImgDlg = true;
            },
            handleRemove(file, fileList) {
                if(fileList.length < 1) {
                    this.hideUpload = false;
                    this.agentInfo.licensePhoto = null;
                }
            },
            handleSuccess(response, file, fileList) {
                if (fileList.length >= 1) {
                    this.hideUpload = true;
                    this.licensePhotoArr = fileList;
                    this.agentInfo.licensePhoto = response.obj.url;
                    console.log('licensePhoto:'+this.agentInfo.licensePhoto);
                }
            },
            handleErr(err, file, fileList) {
                if (fileList.length >= 1) {
                    this.hideUpload = true
                }
            },
            handleChange(value) {
                console.log(value);
            },
            reloadArea () { // 重置组件
                this.areaRest = false;
                this.bankRest = false;
                this.img1Rest = false;
                this.detailRest = false;
                this.$nextTick(() => (this.areaRest = true));
                this.$nextTick(() => (this.bankRest = true));
                this.$nextTick(() => (this.img1Rest = true));
                this.$nextTick(() => (this.detailRest = true));
            },
            initAreaComp() { // 初始化组件传入参数
                // 将服务商表获取的区域3级ID赋予<区域组件>
                this.areas.provId = this.agentInfo.provId;
                this.areas.cityId = this.agentInfo.cityId;
                this.areas.distId = this.agentInfo.distId;
                this.areas.provIdName = this.agentInfo.provIdName;
                this.areas.cityIdName = this.agentInfo.cityIdName;
                this.areas.distIdName = this.agentInfo.distIdName;

                this.reloadArea();
            },
            /**
            viewEdit(data) {
                this.dlgModel = 'UPD';
                this.titleDlg = '编辑服务商信息';
                Object.assign(this.agentInfo, data);

                this.agentPidDisabled = false; // 禁止修改推荐人 true
                this.agentLevelDisabled = false; // 禁止修改等级 true

                // 复制一份推荐人列表，从中删除当前服务商，推荐人不可为自己
                Object.assign(this.agentFromListTemp, this.agentFromList); // (拷贝数组或对象指针内容，'=' 修改数组或对象指针)
                let idx = findIdxByKeyValue(this.agentFromListTemp, 'id', this.agentInfo.id);
                if(idx) this.agentFromListTemp.splice(idx,1);

                // 初始化图片数组，已存在图片时隐藏图片墙添加框
                this.licensePhotoArr = [];
                if(this.agentInfo.licensePhoto) {
                    this.licensePhotoArr.push({url:this.agentInfo.licensePhoto});
                    this.hideUpload = true;
                }
                else {
                    this.hideUpload = false;
                }

                this.initAreaComp();
                this.showDlg = true;
            },
            viewAdd() {
                this.dlgModel = 'INS';
                this.titleDlg = '新增服务商';
                this.agentInfo = {};
                this.areas = {};
                this.agentPidDisabled = false;
                this.agentLevelDisabled = false;
                this.agentInfo.agentLevelId = 3;
                Object.assign(this.agentFromListTemp, this.agentFromList); // 拷贝数组或对象指针内容，'=' 修改数组或对象指针

                this.licensePhotoArr = [];
                this.hideUpload = false;

                this.reloadArea();
                this.showDlg = true;
            },
             */
            viewAdd() {
                this.dlgModel = 'INS';
                this.titleDlg = '新增服务商';
                this.keyCompDlg = Date.now();
                this.showDlg = true;
            },
            viewEdit(data) {
                this.dlgModel = 'UPD';
                this.titleDlg = '编辑服务商信息';
                this.agentInfo = deepClone(data);
                this.keyCompDlg = Date.now();
                this.showDlg = true;
            },
            viewDetail(data) {
                Object.assign(this.agentInfo, data);
                this.drawer = true;
            },
            searchReset() {
                this.searchVal = {};
            },
            searchDo() {
                this.initAgents();
            },
            /*
            //agentStatList:[{id:"0",name:"审核中"},{id:"1",name:"正常"},{id:"2",name:"冻结"},{id:"3",name:"注销"}],
            funFmtAgentStatus(row, column) {
                for(let i=0; i<this.agentStatList.length; i++) {
                    if(this.agentStatList[i].id==row.agentStatus) {
                        return this.agentStatList[i].name;
                    }
                }
                return row.id;
            },*/
            changeAgentStatus(command) {
                let ids = [];
                this.multipleSelection.forEach(item => { ids.push(item.id); });
                this.putRequest("/agent/updateAgentStat" + "?statusId=" + command + "&ids=" + ids).then(resp => {
                    if (resp) {
                        this.initAgents();
                    }
                });
            },
            changeAgentLevel(command) {
                let ids = [];
                this.multipleSelection.forEach(item => { ids.push(item.id); });
                this.putRequest("/agent/updateAgentLevel" + "?levelId=" + command + "&ids=" + ids).then(resp => {
                    if (resp) {
                        this.initAgents();
                    }
                });
            },
            changeAgentPid(command) {
                let ids = [];
                this.multipleSelection.forEach(item => { ids.push(item.id); });
                this.putRequest("/agent/updateAgentPid" + "?pid=" + command + "&ids=" + ids).then(resp => {
                    if (resp) {
                        this.initAgents();
                    }
                });
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if(this.multipleSelection.length>0) {
                    this.disableBtn = false;
                }
                else {
                    this.disableBtn = true;
                }
            },
            initAgents() {
                this.loading = true;
                let url = '/agent/agentInfo?page=' + this.page + '&size=' + this.size;


                if (this.searchVal.keywordMethod && this.searchVal.keyword) {
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                }
                if (this.searchVal.agentLevelId) {
                    url += '&agentLevelId=' + this.searchVal.agentLevelId;
                }
                if (this.searchVal.agentStatId) {
                    url += '&agentStatusId=' + this.searchVal.agentStatId;
                }
                if (this.searchVal.agentPid) {
                    url += '&agentPid=' + this.searchVal.agentPid;
                }

                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.agents = resp.data;
                        this.total = resp.total;
                    }
                })
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initAgents();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initAgents();
            },
            exportData() {
            },
            dlgCommit() {
                switch (this.dlgModel) {
                    case 'SEL':
                        break;
                    case 'UPD':
                        this.updateAgentInfo();
                        break;
                    case 'INS':
                        this.insertAgentInfo();
                        break;
                }
            },
            insertAgentInfo() {
                this.agentInfo.provId = this.areas.provId;
                this.agentInfo.cityId = this.areas.cityId;
                this.agentInfo.distId = this.areas.distId;
                if(!this.agentInfo.provId || this.agentInfo.provId.length==0 || this.agentInfo.cityId==0 || this.agentInfo.distId==0) {
                    this.$message.error("请完善服务商地区信息!");
                    return;
                }
                if(!this.agentInfo.stlBankCnapsCode || this.agentInfo.stlBankCnapsCode.length==0) {
                    this.$message.error("请选择结算开户行!");
                    return;
                }
                if(!this.agentInfo.licensePhoto) {
                    this.$message.error("请上传营业执照图片!");
                    return;
                }


                if (!this.agentInfo.id) { // ID无效，是新增
                    this.$refs['agentForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/agent/addAgent", this.agentInfo).then(resp => {
                                if (resp) {
                                    this.initAgents();
                                    this.showDlg = false;
                                }
                            })
                        }
                    });
                }

            },
            updateAgentInfo() {
                this.agentInfo.provId = this.areas.provId;
                this.agentInfo.cityId = this.areas.cityId;
                this.agentInfo.distId = this.areas.distId;
                if(!this.agentInfo.provId || this.agentInfo.provId.length==0 || this.agentInfo.cityId==0 || this.agentInfo.distId==0) {
                    this.$message.error("请完善服务商地区信息!");
                    return;
                }
                if(!this.agentInfo.stlBankCnapsCode || this.agentInfo.stlBankCnapsCode.length==0) {
                    this.$message.error("请选择结算开户行!");
                    return;
                }
                if(!this.agentInfo.licensePhoto) {
                    this.$message.error("请上传营业执照图片!");
                    return;
                }

                if (this.agentInfo.id) { // ID有效，是更新
                    this.$refs['agentForm'].validate(valid => {
                        if (valid) {
                            this.putRequest("/agent/updateAgent", this.agentInfo).then(resp => {
                                if (resp) {
                                    this.initAgents();
                                    this.showDlg = false;
                                }
                            })
                        }
                    });
                }

            }
        }

    }
</script>

<style scoped>
</style>
